import styled from "styled-components";

function getRowMargins(margin, alt) {
  if (!margin) return;
  let rowMargin = margin / 2;
  let style = alt
    ? `padding-right: 0px;`
    : `padding-left: ${rowMargin}px;padding-right: ${rowMargin}px;`;
  return style;
}

export const Row = styled.div.withConfig({
  shouldForwardProp: (prop) => !['horinzontalAlign', 'verticalalign'].includes(prop),
})`
  display: flex;
  height: auto;
  width: 100%;
  flex-wrap: wrap;
  justify-content: ${(props) =>
    props.horinzontalAlign && props.horinzontalAlign === "center"
      ? "center"
      : "flex-start"};
  align-items: ${(props) =>
    props.verticalalign && props.verticalalign === "center"
      ? "center"
      : "flex-start"};

  ${({ alt }) => getRowMargins(16, alt)};

  @media only screen and (min-width: 769px) {
    ${({ alt }) => getRowMargins(16, alt)};
  }

  @media only screen and (min-width: 1025px) {
    ${({ alt }) => getRowMargins(24, alt)};
  }

  @media only screen and (min-width: 1281px) {
    ${({ alt }) => getRowMargins(24, alt)};
  }
`;

function getColumnWidth(span, gutter, alt, vw) {
  if (!span) return;
  let colMargin = gutter / 2;
  let altGutter = alt ? `0` : gutter;
  let width = vw
    ? ((vw - gutter) / 12) * span + `px` + ` - ` + altGutter + `px`
    : (span / 12) * 100 + `%` + ` - ` + altGutter + `px`;
  let calc = `calc(` + width + `)`;
  let style = vw
    ? `width: ${calc};margin-left: ${colMargin}px;margin-right: ${colMargin}px`
    : alt
    ? `width: ${calc};margin-right: ${colMargin}px;`
    : `width: ${calc};margin-left: ${colMargin}px;margin-right: ${colMargin}px;`;

  return style;
}

export const Column = styled.div`
  display: inline-flex;
  height: inherit;
  align-items: center;
  word-break: keep-all;
  color: ${(props) =>
    props.color ? props.color : props.theme.fontGrey} !important;
  ${({ xs, vw, alt }) => (xs ? getColumnWidth(xs, 16, alt) : "width: 100%")};

  @media only screen and (min-width: 769px) {
    ${({ sm, alt, vw }) => sm && getColumnWidth(sm, 16, alt, vw)};
  }

  @media only screen and (min-width: 1025px) {
    ${({ md, alt, vw }) => md && getColumnWidth(md, 24, alt, vw)};
  }

  @media only screen and (min-width: 1281px) {
    ${({ lg, alt, vw }) => lg && getColumnWidth(lg, 24, alt, vw)};
  }
`;
